/**!
 * Created by Leonardo Cheslacki on 20/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import StageController from './StageController';

import {HelpersIcon, HelpersPin} from './../helpers';

import Big from 'big.js';

import VARIABLES from './../../../../variables.json';

import config from '../../../../config';

const {default: {domain, routes: {web}, implantation, text, button}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class StagePin extends StageController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main = {}) {
        super(props);
        this.props = props;
        this.main = main;

        const {current_name} = this.props;

        this.state = {
            data: [] || {},
            bitmap: null
        };

        this.$helpersIcon = HelpersIcon(this)({current_name: current_name});

        this.$children_temp = [];

        this.$isShow = false;

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         * @param _pin
         * @param _this_current
         * @param _this_frame
         * @param properties
         * @param product
         */
        handleModalOpen: function (event, {_pin, _this_current, _this_frame, properties, product}) {
            _this.$isShow = true;

            const
                {
                    text: {font, font_size, weight},
                    modal: {scale, padding_vertical, padding_horizontal, color_symbol},
                    modal,
                } = _this.props,
                {bitmap, symbol_rectangle, symbol_text} = _this.state,
                {uri} = _pin.state;

            let
                occ_modal = _this.verifyField(_this_frame, 'occ_modal') || _this.verifyField(_this_current, 'occ_modal'),
                occ_modal_background = _this.verifyField(_this_frame, 'occ_modal_background') || _this.verifyField(_this_current, 'occ_modal_background'),
                btn_close = _this.verifyField(_this_frame, 'btn_close') || _this.verifyField(_this_current, 'btn_close');

            let occ_hide_menu = _this.verifyField(_this_current, 'occ_hide_menu');

            bitmap && occ_modal.removeChild(bitmap);
            symbol_rectangle && occ_modal.removeChild(symbol_rectangle);
            symbol_text && occ_modal.removeChild(symbol_text);

            _this.state.bitmap = (new createjs.Bitmap(uri));
            _this.state.bitmap.image.onload = () => {
                let
                    _scale = _this.verifyField(product, 'scale.value', false, scale),
                    scaleX = (_this.state.bitmap.scaleX * _this.toFloat(_scale)),
                    scaleY = (_this.state.bitmap.scaleY * _this.toFloat(_scale)),
                    bounds = _this.state.bitmap.getBounds(),
                    big_width = _this.calcSize(1, scaleX, bounds.width, true),
                    big_height = _this.calcSize(1, scaleY, bounds.height, true);

                _this.state.bitmap.scaleX = scaleX;
                _this.state.bitmap.scaleY = scaleY;

                occ_modal.x = _this.bigToNumber((new Big(properties.width)).minus(big_width).div(_this.$controller.big_2), false, 'up');
                occ_modal.y = _this.bigToNumber((new Big(properties.height)).minus(big_height).div(_this.$controller.big_2), false, 'up');

                /**
                 * Create Legend
                 * @type {string}
                 */
                let
                    text = _this.toCapitalize(_this.verifyField(product, 'text.value')).toUpperCase(),
                    font_attribute = `${(!_this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${font_size}px '${font}'`,
                    color = _this.tintToHex(modal.color_text),
                    color_alfa = `${_this.tintToHex(color_symbol)}80`;


                _this.state.symbol_text = (new createjs.Text(text, font_attribute, color));
                _this.state.symbol_rectangle = (new createjs.Shape());
                let bounds_text = _this.state.symbol_text.getBounds();

                let
                    big_text_width = (new Big(bounds_text.width)),
                    big_text_height = (new Big(bounds_text.height)),
                    symbol_x = big_width.div(_this.$controller.big_2),
                    symbol_y = big_height.minus(big_text_height),
                    big_padding_horizontal = (new Big(padding_horizontal)),
                    big_padding_vertical = (new Big(padding_vertical));

                let
                    x = _this.bigToNumber(symbol_x.minus(big_text_width.plus(big_padding_horizontal).div(_this.$controller.big_2))),
                    y = _this.bigToNumber(big_height.minus(big_text_height.plus(big_padding_vertical))),
                    width = _this.bigToNumber(big_text_width.plus(big_padding_horizontal)),
                    height = _this.bigToNumber(big_text_height.plus(big_padding_vertical));

                _this.state.symbol_text.textAlign = 'center';
                _this.state.symbol_text.x = _this.bigToNumber(symbol_x);
                _this.state.symbol_text.y = _this.bigToNumber(symbol_y);

                _this.state.symbol_rectangle.graphics.beginFill(color_alfa).drawRect(x, y, width, height);

                /**
                 * End Create Legend
                 */
                occ_modal.addChild(_this.state.bitmap);
                occ_modal.addChild(_this.state.symbol_rectangle);
                occ_modal.addChild(_this.state.symbol_text);
            }

            _this.$children_temp = _this_frame.children;

            _this_frame.children = _this_frame.children.filter((value) => {
                return _this.inArray(VARIABLES.modalIgnore, value.name);
            });

            occ_hide_menu && (occ_hide_menu.visible = true);
            occ_modal_background.visible = true;

            btn_close.visible = true;

            _this.effectFadeIn(occ_modal.parent, 'occ_modal');
        },

        handleModalClose: function () {
            if (_this.$isShow) {
                _this.$isShow = false;

                const
                    _this_current = _this.get(),
                    _this_frame = _this.getFrame(),
                    {bitmap} = _this.state;

                let
                    occ_modal = _this.verifyField(_this_frame, 'occ_modal') || _this.verifyField(_this_current, 'occ_modal'),
                    occ_modal_background = _this.verifyField(_this_frame, 'occ_modal_background') || _this.verifyField(_this_current, 'occ_modal_background'),
                    btn_close = _this.verifyField(_this_frame, 'btn_close') || _this.verifyField(_this_current, 'btn_close');

                let occ_hide_menu = _this.verifyField(_this.get(), 'occ_hide_menu');

                _this.effectFadeOut(occ_modal.parent, 'occ_modal', () => {
                    bitmap && occ_modal.removeChild(bitmap);

                    _this_frame.children = _this.$children_temp;

                    occ_hide_menu && (occ_hide_menu.visible = false);
                    occ_modal_background.visible = false;

                    btn_close.visible = false;
                });
            }
        },

        handlePinsSwitch: function () {
            const {occ_icon_pins} = _this.getFrame();
            _this.switchPins(!occ_icon_pins.occ_more.isVisible())
        }
    };

    /**
     *
     * @param visible
     */
    switchPins = (visible = false) => {
        const
            _this_frame = _this.getFrame(),
            {occ_plant, occ_icon_pins} = _this_frame;
        occ_icon_pins.occ_more.visible = visible;
        occ_icon_pins.occ_less.visible = !visible;
        occ_plant.occ_pins.visible = !visible;

        _this.$helpersIcon.setColor(occ_icon_pins, button.color_icon, 'occ_less');
        _this.$helpersIcon.setColor(occ_icon_pins, button.color_icon, 'occ_more');
    };

    clonePin = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(this)({current_name: 'pins'}),

            /**
             *
             * @returns {null}
             */
            get pin() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pin(object) {
                this.object = object;
            },

            clone() {
                const _this_frame = _this.getFrame(), {content_pin} = _this_frame;
                this.pin = content_pin.clone();
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color = null, font = null, size = null, weight = null) {
                const {occ_align: {occ_text: {occ_number}}} = this.object;
                this.helpersPin.setNumber(occ_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const occ_color = _this.verifyField(this.object, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_align: {occ_effect}} = this.object;
                this.helpersPin.setAnimate(occ_effect, visible);
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                this.helpersPin.setAction(_this, this.object, enabled, cursor, uri);
            }
        }
    };

    clonePinText = (_this) => {
        return {
            object: null,
            helpersPin: HelpersPin(_this)({current_name: 'pins'}),

            /**
             *
             * @returns {null}
             */
            get pinText() {
                return this.object;
            },

            /**
             *
             * @param object
             */
            set pinText(object) {
                this.object = object;
            },

            clone() {
                const _this_frame = _this.getFrame(), {content_pin_text} = _this_frame;
                this.pinText = content_pin_text.clone();
            },

            /**
             *
             * @param string
             * @param color
             * @param font
             * @param size
             * @param weight
             * @param capitalize
             * @param upper_case
             */
            setText(string, color, font, size, weight, capitalize, upper_case) {
                const {occ_text} = this.object;

                let y = (new RegExp(/%n/g)).test(string) ? 0 : null;

                this.helpersPin.setText(occ_text, string, color, font, size, weight, null, y, capitalize, upper_case);
            },

            /**
             *
             * @param number
             * @param x
             * @param y
             * @param color
             * @param font
             * @param size
             * @param weight
             */
            setNumber(number, x, y, color = null, font = null, size = null, weight = null) {
                const {occ_align: {occ_text: {occ_number}}} = this.object;
                this.helpersPin.setNumber(occ_number, number, x, y, color, font, size, weight);
            },

            /**
             *
             * @param color
             * @param occ
             */
            setColor(color, occ) {
                const occ_color = _this.verifyField(this.object, occ, false, []);
                this.helpersPin.setColor(occ_color, color);
            },

            /**
             *
             * @param x
             * @param y
             */
            setCoordinate(x, y) {
                this.helpersPin.setCoordinate(this.object, x, y);
            },

            /**
             *
             * @param visible
             */
            setAnimate(visible) {
                const {occ_align: {occ_effect}} = this.object;
                this.helpersPin.setAnimate(occ_effect, visible);
            },

            /**
             *
             * @param enabled
             * @param cursor
             * @param uri
             */
            setAction(enabled, cursor, uri) {
                this.helpersPin.setAction(_this, this.object, enabled, cursor, uri);
            }
        }
    };

    startPin = () => {
        const
            {
                modal: {composition_name},
                pin: {number_x, number_y, color_disabled, color_enabled, color_round},
                text: {text_y, color_text, color_number, font, font_size, weight, capitalize, upper_case},
                content_text,
            } = this.props,
            {data} = this.state,
            _this_current = this.get(),
            _this_frame = this.getFrame(),
            current_frame = this.occurrence(),
            {properties} = this.getComposition(composition_name).getLibrary(),
            {occ_plant, btn_pins} = _this_frame,
            frame = content_text[`frame_${current_frame}`];


        let btn_close = this.verifyField(_this_frame, 'btn_close') || this.verifyField(_this_current, 'btn_close');

        let
            //x = 0;
            y = 0,
            count = 0,
            letter = 0,
            total = 0,
            frame_keys = null,
            pin_default_color = color_disabled;

        occ_plant.occ_pins.removeAllChildren();

        if (this.isObjectIf(frame)) {
            frame_keys = Object.keys(frame);
            for (let property in frame) {
                _this_frame[`content_text_${current_frame}${property}`].removeAllChildren();
            }
        }

        this.recursiveSyncMap(data, 0, data.length, (item, next, stop, index) => {
            const
                product = this.verifyField(item, 'product'),
                pin = this.clonePin(this),
                pin_text = this.clonePinText(this),
                _id = this.verifyField(item, 'attributes.id').value,
                _allow = this.verifyField(item, 'attributes.allow').value,
                image = this.verifyField(product, 'src').value;

            if (this.hasString(_allow, 'plant')) {
                image && (pin_default_color = color_enabled);

                if (this.isArrayIf(frame_keys) && letter <= frame_keys.length) {
                    total = this.verifyField(frame, `${frame_keys[letter]}`);
                }

                /**
                 * Clone pin
                 */
                pin.clone();

                pin.setNumber(this.verifyField(product, 'number.value', false, 0), number_x, number_y, color_number);
                pin.setColor(this.verifyField(product, 'tintColor.value', false, pin_default_color), 'occ_align.occ_color');
                pin.setColor(color_round, 'occ_align.occ_background.occ_round');
                pin.setColor(color_round, 'occ_align.occ_effect.occ_round');
                pin.setColor(color_round, 'occ_align.occ_effect.occ_animate.occ_round_first');
                pin.setColor(color_round, 'occ_align.occ_effect.occ_animate.occ_round_second');
                pin.setCoordinate(this.verifyField(product, 'x.value', false, 0), this.verifyField(product, 'y.value', false, 0));

                /**
                 * Clone pin text
                 */
                pin_text.clone();

                if (!this.isIdCompound(_id)) {
                    /**
                     * Clone pin text
                     */
                    pin_text.setNumber(this.verifyField(product, 'number.value', false, 0), number_x, number_y, color_number);
                    pin_text.setText(this.verifyField(product, 'text.value'), color_text, font, font_size, weight, capitalize, upper_case);
                    pin_text.setColor(this.verifyField(product, 'tintColor.value', false, pin_default_color), 'occ_align.occ_color');
                    pin_text.setColor(color_round, 'occ_align.occ_background.occ_round');
                    pin_text.setColor(color_round, 'occ_align.occ_effect.occ_round');
                    pin_text.setColor(color_round, 'occ_align.occ_effect.occ_animate.occ_round_first');
                    pin_text.setColor(color_round, 'occ_align.occ_effect.occ_animate.occ_round_second');
                    pin_text.setCoordinate(0, y);
                    //pin_text.setCoordinate(x, 10);
                    //let count = ((text.length * 9) + 37);
                    //x += count < pin_text_default_x ? pin_text_default_x : count;
                }

                if (image) {
                    let _index = this.padWithLeadingZeros(index, 2);

                    /**
                     * Clone pin
                     */
                    pin.setAnimate(true);
                    pin.setAction(true, 'pointer', `${this.$base_uri}/${web.uri_images}/${image}`);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(true);
                        pin_text.setAction(true, 'pointer', `${this.$base_uri}/${web.uri_images}/${image}`);
                    }

                    let handle_name_pin = this.toHandleName(_index, 'pin');

                    this[handle_name_pin] && pin.pin.off('mousedown', this[handle_name_pin]);
                    this[handle_name_pin] = pin.pin.on('mousedown', this.$functions.handleModalOpen, false, false, {
                        _pin: pin.pin,
                        _this_current: _this_current,
                        _this_frame: _this_frame,
                        properties: properties,
                        product: product
                    });

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        let handle_name_pin_text = this.toHandleName(_index, 'pin_text');

                        this[handle_name_pin_text] && pin_text.pinText.off('mousedown', this[handle_name_pin_text]);
                        this[handle_name_pin_text] = pin_text.pinText.on('mousedown', this.$functions.handleModalOpen, false, false, {
                            _pin: pin_text.pinText,
                            _this_current: _this_current,
                            _this_frame: _this_frame,
                            properties: properties,
                            product: product
                        });
                    }
                } else {
                    /**
                     * Clone pin
                     */
                    pin.setAnimate(false);
                    pin.setAction(false, 'default', null);

                    /**
                     * Clone pin text
                     */
                    if (!this.isIdCompound(_id)) {
                        pin_text.setAnimate(false);
                        pin_text.setAction(false, 'default', null);
                    }
                }

                /**
                 * Clone pin
                 */
                occ_plant.occ_pins.addChild(pin.pin);

                /**
                 * Clone pin text
                 */
                if (!this.isIdCompound(_id)) {
                    y += text_y;
                    count += 1;

                    if (this.isArrayIf(frame_keys) && letter <= frame_keys.length) {
                        if (total && total >= count) {
                            _this_frame[`content_text_${current_frame}${frame_keys[letter]}`].addChild(pin_text.pinText);
                        }
                    }
                }

                if (this.isArrayIf(frame_keys) && letter <= frame_keys.length) {
                    if (total && total === count) {
                        y = 0;
                        letter += 1;
                    }
                }
            }
            next(true);
        });

        this.setHandleMouseDown(btn_close, this.$functions.handleModalClose);

        this.setHandleMouseDown(btn_pins, this.$functions.handlePinsSwitch);

        this.main.$closeModal.pin = this.$functions.handleModalClose;
    };

    initPin = () => {
        const {xml} = this.props;

        this.getForm(`${this.$base_uri || domain}/${web.uri_xml}/${xml}`, {}, {
            done: (response) => {
                let
                    object = this.firstArray(this.xmlToJson(response)),
                    products = this.getObject(object, 'products');

                this.setState({...this.state, data: products}, this.startPin);
            },
            fail: (response) => {
                console.log(response);
            },
            always: () => {
                this.switchPins();
            }
        });
    };
}

/**
 *
 * @type {{}}
 */
StagePin.propTypes = {
    current_name: PropTypes.string,
    xml: PropTypes.string,
    pin: PropTypes.shape({
        number_x: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        number_y: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        color_enabled: PropTypes.string,
        color_disabled: PropTypes.string,
        color_round: PropTypes.string
    }),
    text: PropTypes.shape({
        text_x: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]),
        text_y: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]),
        color_number: PropTypes.string,
        color_text: PropTypes.string,
        font_size: PropTypes.number,
        capitalize: PropTypes.bool
    }),
    modal: PropTypes.shape({
        scale: PropTypes.number,
        composition_name: PropTypes.string,
        padding_vertical: PropTypes.number,
        padding_horizontal: PropTypes.number,
        color_symbol: PropTypes.string
    }),
    content_text: PropTypes.object
};

/**
 *
 * @type {{}}
 */
StagePin.defaultProps = {
    current_name: null,
    ...implantation,
    text: {...implantation.text, ...text}
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(StagePin, {className: 'StagePin'});
